export const ADMIN_USER_STATUS = {
  UNACTIVATED: 'UNACTIVATED',
  ACTIVATED: 'ACTIVATED',
  BLOCKED: 'BLOCKED',
}